<template>
  <v-layout row wrap>
    <v-flex xs12 md8>
      <v-client-list v-if="isRoot"></v-client-list>
      <v-client-page :mode = "'page'" :fullscreen = "$vuetify.breakpoint.xsOnly" :itemId = "itemId" :profileId="profileId" v-if="itemId !== null && itemId !== 'root'"></v-client-page>
      <v-human-page :mode = "'page'" :fullscreen = "$vuetify.breakpoint.xsOnly" :itemId = "humanId" v-if="humanId !== null"></v-human-page>
      <v-foreign-agency-page :mode = "'page'" :fullscreen = "$vuetify.breakpoint.xsOnly" :itemId = "fagencyId" v-if="fagencyId !== null"></v-foreign-agency-page>
      <v-foreign-page :mode = "'page'" :fullscreen = "$vuetify.breakpoint.xsOnly" :itemId = "foreignId" v-if="foreignId !== null"></v-foreign-page>
      <v-loner-page :mode = "'page'" :fullscreen = "$vuetify.breakpoint.xsOnly" :itemId = "lonerId" v-if = "lonerId !== null  "></v-loner-page>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vClientList from './ClientList.vue'
  import vClientPage from '../info/ClientPage.vue'
  import vHumanPage from '../info/HumanPage.vue'
  import vForeignPage from '../info/ForeignPage.vue'
  import vForeignAgencyPage from '../info/ForeignAgencyPage.vue'
  import vLonerPage from '../info/LonerPage.vue'

  export default {
    name: 'client-panel',
    components: {vClientList, vClientPage, vHumanPage, vForeignPage, vForeignAgencyPage, vLonerPage},
    props: {
    },
    data: () => ({
      isRoot: true,
      itemId: null,
      humanId: null,
      foreignId: null,
      fagencyId: null,
      lonerId: null
    }),
    created () {
      this.setItemId()
    },
    mounted () {
      this.setItemId()
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
      '$route' () {
        this.setItemId()
      }
    },
    computed: {
      ...mapGetters({
      }),
      title () {
      }
    },
    methods: {
      setItemId () {
        if (this.$route.params.humanId) {
          this.humanId = this.$route.params.humanId
        } else {
          this.humanId = null
        }
        if (this.$route.params.foreignId) {
          this.foreignId = this.$route.params.foreignId
        } else {
          this.foreignId = null
        }
        if (this.$route.params.fagencyId) {
          this.fagencyId = this.$route.params.fagencyId
        } else {
          this.fagencyId = null
        }
        if (this.$route.params.ogrnip) {
          this.lonerId = this.$route.params.ogrnip
        } else {
          this.lonerId = null
        }
        if (this.$route.params.clientInn) {
          this.itemId = this.$route.params.clientInn
          this.profileId = this.$route.query.profileId
        } else {
          this.itemId = null
          this.profileId = null
        }
        if (!this.humanId && !this.foreignId && !this.itemId && !this.fagencyId && !this.lonerId) {
          this.isRoot = true
        } else {
          this.isRoot = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientPanel.vue?07967fee